"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY_CODE = exports.DEVICE_TYPE = exports.BREAKPOINTS = exports.ARR_DEVICE_TYPE = void 0;
var DEVICE_TYPE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  TABLET: 'tablet'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var KEY_CODE = {
  ENTER: 13,
  ESC: 27
};
exports.KEY_CODE = KEY_CODE;
var BREAKPOINTS = {
  SMALL_MOBILE: '320px',
  MOBILE: '599px',
  SMALL_TABLET: '600px',
  MEDIUM_TABLET: '720px',
  LARGE_TABLET: '840px',
  DESKTOP: '1280px'
};
exports.BREAKPOINTS = BREAKPOINTS;
var ARR_DEVICE_TYPE = Object.keys(DEVICE_TYPE);
exports.ARR_DEVICE_TYPE = ARR_DEVICE_TYPE;